import { useNavigate } from "react-router";
import type { PracticeFormat } from "../../domain/vocabulary/types.ts";
import { useAppServices } from "../hooks/AppContext.tsx";
import { usePractice } from "../hooks/bindings.ts";
import { BottomNav, Frame, PrimaryButton, Screen } from "../components/Shell.tsx";
import styles from "../design-system/ui.module.css";

const FORMATS: Array<{ id: PracticeFormat; title: string; detail: string }> = [
  { id: "written", title: "Write answer", detail: "Type the word or choose the matching meaning." },
  { id: "cards", title: "Cards", detail: "Reveal a saved meaning and say whether you recalled it." },
];

export function PracticeSetupScreen() {
  const { practice } = useAppServices();
  const state = usePractice();
  const navigate = useNavigate();

  return (
    <Frame>
      <Screen>
        <header className={styles.pageHead}>
          <span className={styles.greeting}>A LITTLE PRACTICE GOES A LONG WAY</span>
          <h1>Let’s practice!</h1>
          <p>Choose a type. The next screen asks how that session should work.</p>
        </header>
        {FORMATS.map((format) => {
          const active = state.setup.format === format.id;
          return (
            <label key={format.id} className={`${styles.radioRow} ${active ? styles.radioRowActive : ""}`}>
              <input type="radio" name="format" checked={active} onChange={() => practice.setFormat(format.id)} />
              <span>
                <strong>{format.title}</strong>
                <div className={styles.sub}>{format.detail}</div>
              </span>
            </label>
          );
        })}
        <PrimaryButton onClick={() => navigate("/practice/setup")}>Continue</PrimaryButton>
      </Screen>
      <BottomNav />
    </Frame>
  );
}
